export default __webpack_public_path__ + "static/media/new-arrow-right-purple.4905971e.svg";